import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import StudentAvatarView from '../../shared/StudentAvatarView';
import { teacherTypography } from '../../design/typography';
import ReplayIcon from '@mui/icons-material/Replay';
import CheckIcon from '@mui/icons-material/Check';

const action = {
  ...teacherTypography.action,
  minHeight: 44,
  width: { xs: 'auto', sm: 112 },
  flex: { xs: 1, sm: '0 0 auto' },
  minWidth: 0,
  px: { xs: 0.75, sm: 1.5 },
  py: 1,
  fontSize: { xs: 13, sm: 14 },
  borderRadius: '8px',
  lineHeight: 1.2,
  whiteSpace: 'nowrap',
  boxShadow: 'none',
  '&:focus-visible': { outline: '3px solid #352179', outlineOffset: 2 },
};

function CeteleEvaluationRow({ student, status, saving, onMark }) {
  return <Box data-cetele-student-id={student.id}
    role="group" aria-label={student.name + ' değerlendirmesi'}
    aria-busy={saving ? 'true' : 'false'}
    sx={{ display: { xs: 'grid', sm: 'flex' }, alignItems: 'center',
      gridTemplateColumns: { xs: '44px minmax(0, 1fr)', sm: 'none' },
      gap: { xs: 1, sm: 1.5 }, minWidth: 0,
      px: { xs: 0, sm: 1 }, py: 1.25,
      borderBottom: '1px solid #e8eaf3',
      '&:last-of-type': { borderBottom: 0 },
      '&:hover': { bgcolor: '#fbfaff' } }}>
    <StudentAvatarView studentId={student.id} avatarId={student.avatar_id}
      starterEmoji={student.starter_emoji} name={student.name} size={44}
      sx={{ flexShrink: 0 }} />
    <Box sx={{ flex: '1 1 auto', minWidth: 0 }}>
      <Typography title={student.name} sx={{
        ...teacherTypography.studentName,
        overflowWrap: 'anywhere',
        lineHeight: 1.5,
      }}>{student.name}</Typography>
      {saving && <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.25 }}>
        <CircularProgress size={10} aria-hidden="true" />
        <Typography role="status" sx={{ ...teacherTypography.metadata, fontSize: 12,
          overflowWrap: 'anywhere' }}>Kaydediliyor</Typography>
      </Box>}
    </Box>
    <Stack direction="row" spacing={1} sx={{ flexShrink: 0,
      gridColumn: { xs: 2, sm: 'auto' }, width: { xs: '100%', sm: 'auto' } }}>
      <Button type="button" disableFocusRipple disabled={saving}
        aria-label={student.name + ': Tekrar'}
        aria-pressed={status === 'retry'}
        variant={status === 'retry' ? 'contained' : 'outlined'}
        onClick={() => onMark('retry')}
        sx={{ ...action, bgcolor: status === 'retry' ? '#a84b0b' : '#fff',
          color: status === 'retry' ? '#fff' : '#99501b',
          borderColor: '#ac632a',
          '&:hover': { bgcolor: status === 'retry' ? '#8f3f08' : '#fff7ed',
            borderColor: '#8f3f08' },
          '&.Mui-disabled': status === 'retry'
            ? { bgcolor: '#f8d9bc', color: '#85430f' }
            : { color: '#805b3b', borderColor: '#d2b79e', bgcolor: '#faf6f1' } }}>
        <ReplayIcon sx={{ display: { xs: 'none', sm: 'inline' }, fontSize: 18, mr: 0.75 }} />
        Tekrar
      </Button>
      <Button type="button" disableFocusRipple disabled={saving}
        aria-label={student.name + ': Öğrendi'}
        aria-pressed={status === 'pass'}
        variant={status === 'pass' ? 'contained' : 'outlined'}
        onClick={() => onMark('pass')}
        sx={{ ...action, bgcolor: status === 'pass' ? '#207848' : '#fff',
          color: status === 'pass' ? '#fff' : '#207848',
          borderColor: '#42835d',
          '&:hover': { bgcolor: status === 'pass' ? '#196d3a' : '#f1fbf5',
            borderColor: '#258448' },
          '&.Mui-disabled': status === 'pass'
            ? { bgcolor: '#b8dfc4', color: '#17532d' }
            : { color: '#486c55', borderColor: '#b1c9b9', bgcolor: '#f2f7f4' } }}>
        <CheckIcon sx={{ display: { xs: 'none', sm: 'inline' }, fontSize: 18, mr: 0.75 }} />
        Öğrendi
      </Button>
    </Stack>
  </Box>;
}

export default React.memo(CeteleEvaluationRow);
